import styled from "styled-components/macro";

export const LockBoxOverlay = styled.div`
  display: ${({ lock }) => (lock ? "block" : "none")};
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 10000;
`;
